<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      :rules="rules"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="12">
        <el-col>
          <el-form-item label="分类名称：" prop="categoryName" required>
            <el-input
              v-model="curdForm.categoryName"
              placeholder="请输入分类名称"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            class="scale"
            label="品类图标："
            prop="iconUrl"
            :show-message="showError"
          >
            <av-preview
              v-if="curdForm.iconUrl"
              :src="curdForm.iconUrl"
              type="image"
              @delete="deleteCover"
            />
            <upload
              v-else
              :draggable="false"
              :path="'shortCategory/img'"
              type="image"
              v-model="curdForm.covers"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            class="scale"
            label="是否上线："
            prop="onlineStatus"
            required
          >
            <el-radio-group v-model="curdForm.onlineStatus">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";
import vue from "@/main";
import AvPreview from "@/components/av-preview/index";
import Upload from "@/components/upload/index";
import { save, getInfo, update } from "@/api/shortCategory";

export default {
  components: { butn, AvPreview, Upload },
  data() {
    return {
      curdForm: {
        uuid: "",
        categoryName: "",
        iconUrl: "",
        onlineStatus: 1
      },
      rules: {
        categoryName: [
          {
            required: true,
            message: "请输入分类名称",
            trigger: ["blur", "change"]
          },
          {
            min: 0,
            max: 8,
            message: "最多输入8个字",
            trigger: "change"
          }
        ]
      },
      curdTitle: "",
      CUFlag: false,
      showError: false
    };
  },
  created() {
    let _this = this;
    vue.$on("curdCategory", item => {
      _this.$nextTick(() => {
        _this.curdTitle = item.uuid == "" ? "新增分类" : "编辑分类";
        _this.command = item.uuid == "" ? save : update;
        _this.CUFlag = true;
        _this.curdForm = {
          uuid: "",
          categoryName: "",
          iconUrl: "",
          onlineStatus: 1
        };
        if (item.uuid) {
          getInfo(item.uuid).then(res => {
            if (!res || res.code != 0) return;
            _this.curdForm = res.data;
          });
        }
      });
    });
    // 获取通用数据字典数据
    getDataMap("IS_VALID").then(res => {
      if (!res || res.code != 0) return;
      this.publicData = res.data
        .sort(function(a, b) {
          return parseInt(b.paramKey) - parseInt(a.paramKey);
        })
        .map(ele => {
          ele.paramKey = parseInt(ele.paramKey);
          return ele;
        });
    });
  },
  methods: {
    createData() {
      this.$refs.curdForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const params = Object.assign({}, this.curdForm);
          this.command(params).then(res => {
            this.loading = false;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              vue.$emit("reload");
              this.CUFlag = false;
            }
          });
        }
      });
    },
    closeDialog() {
      // 点击取消 数据重置
      this.CUFlag = false;
      this.$refs["curdForm"].resetFields();
    },

    // 删除封面
    deleteCover() {
      this.curdForm.covers = [];
    }
  },
  beforeDestroy() {
    vue.$off("curdCategory");
  },
  watch: {
    "curdForm.covers": {
      handler(val) {
        if (val && val.length > 0) {
          this.curdForm.iconUrl = val[0].url;
          this.showError = false;
        } else {
          this.curdForm.iconUrl = "";
          this.showError = true;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
